import { useContext } from "react";
import { makeStyles } from 'tss-react/mui';
import { Chip, Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import { IoMdCheckbox as CheckIcon, IoMdClose as CloseIcon } from 'react-icons/io';
import { IoBuildOutline as MaintenanceIcon } from 'react-icons/io5';
import { useHistory } from 'react-router-dom';
import { toolsContext } from '../ToolsContext';
import moment from "moment";
import { colors } from '@mui/material';
import { ClickableTableRow, DeleteIconButton, EditIconButton, NotesIconTooltip, SimecUser } from "components";
import { applicationContext } from "helpers/services";

let useStyles = makeStyles()(() => ({
    bgDanger: {
        backgroundColor: colors.red[600],
        color: '#FFFFFF'
    },
    paddingLeft: {
        paddingLeft: 4
    }
}));

let Results = () => {
    let history = useHistory();
    let { classes } = useStyles();

    let { toolTypologies } = useContext(applicationContext);
    let service = useContext(toolsContext);

    return (
        <Grid container>
            <Grid item xs>
                {service.recordCount === 0 &&
                    <Typography gutterBottom variant="subtitle2">Nessuno Strumento trovato</Typography>
                }
                {service.recordCount > 0 &&
                    <>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Seriale</TableCell>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>Tipologia</TableCell>
                                    <TableCell align="center">Disponibile</TableCell>
                                    <TableCell>Assegnato a</TableCell>
                                    <TableCell>Ultima Manutenzione</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {service.tools.map((tool, index) =>
                                    <ClickableTableRow
                                        hover
                                        key={index}
                                        onClick={() => history.push(`/tool/${tool.toolId}`)}
                                    >
                                        <TableCell>{tool.serialNumber}</TableCell>
                                        <TableCell>{tool.name}</TableCell>
                                        <TableCell>{toolTypologies.find(f => f.toolTypologyId === tool.toolTypologyId)?.name || ''}</TableCell>
                                        <TableCell align="center">
                                            {tool.isAvailable === true && <CheckIcon />}
                                            {tool.isAvailable === false && <CloseIcon />}
                                        </TableCell>
                                        <TableCell>
                                            <SimecUser username={tool.usedByUserName} />
                                        </TableCell>
                                        <TableCell>
                                            {tool.lastMaintenanceDate != null && moment(tool.lastMaintenanceDate).format("DD/MM/YYYY")}
                                        </TableCell>
                                        <TableCell>
                                            {tool.needMaintenance === true &&
                                                <Chip
                                                    icon={<MaintenanceIcon className={classes.bgDanger} />}
                                                    className={`${classes.bgDanger} ${classes.paddingLeft}`}
                                                    label="Manutenzione Necessaria"
                                                />
                                            }
                                        </TableCell>
                                        <TableCell align="right">
                                            {tool.notes != null && tool.notes !== '' &&
                                                <NotesIconTooltip notes={tool.notes} stopPropagation />
                                            }
                                            <EditIconButton link={`/tool/edit/${tool.toolId}`} stopPropagation />
                                            <DeleteIconButton onClick={() => service.deleteTool(tool.toolId)} stopPropagation />
                                        </TableCell>
                                    </ClickableTableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            style={{ padding: 0 }}
                            count={service.recordCount}
                            onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                            page={service.search.pageNr}
                            rowsPerPage={service.search.pageSize}
                            rowsPerPageOptions={[service.search.pageSize]}
                            labelDisplayedRows={({ page, count }) =>
                                <>
                                    Strumenti totali:&nbsp;{count} &nbsp;&middot;&nbsp;
                                    <span>Pagina {page + 1} di {Math.ceil(count / service.search.pageSize)}</span>
                                </>
                            }
                        />
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default Results;